<template>
<div class="kdx-news-detail">
    <div class="nav-crumb-top">
        <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
        <span @click="goHome">首页</span>/
        <span>项目介绍</span>
    </div>
    <div class="project-content-layer">
        <div class="project-content-title">餐饮管理运行职业技能等级证书</div>
        <div class="project-content">
            <p v-html="newsInfo.Content"></p>
            <p>主要面向邮政快递相关领域，从事快递服务生产作业、生产管理以及业务流程优化和运行管理等各类相关岗位（群）。</p>

            <p>对应专业：</p>

            <p>（1）中等职业单位:餐饮管理运行、邮政通信管理、物流服务与管理、电子商务、农产品营销与储运、客户信息服务等专业。</p>

            <p>（2）高等职业单位:餐饮管理运行、邮政通信管理、物流管理、物流信息技术、冷链物流技术与管理、报关与国际货运、电子商务、跨境电子商务、工商企业管理、物流工程技术等专业。</p>

            <p>（3）应用型本科单位:邮政工程、邮政管理、物流工程、物流管理、电子商务、市场营销等专业。 </p>

            <!--  <p>教育部同时建立“学分银行”制度，建设信息系统，学生和社会成员在按规定程序进入试点院校接受相关专业学历教育时，可按规定兑换学分，免修相应课程，促进学历证书与职业技能等级证书互通。</p> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        newsId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            newsInfo: {},
            isShow: 1,
        };
    },
    created() {},
    methods: {
        //返回首页
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
    },
}
</script>

<style lang="scss">
.kdx-news-detail {
    width: 1200px;
    margin: 0 auto;

    .nav-crumb-top {
        margin-top: 23px;
    }

    .project-content-layer {
        margin-top: 30px;
        background: #F0F0F0;
        border-top: 4px solid #05243D;
        padding: 40px;

        .project-content-title {
            text-align: center;
            color: #05243D;
            font-size: 18px;
            margin: 15px 0 52px 0;
        }

        .project-content {
            color: #646464;
            font-size: 14px;
            line-height: 23px;

            p {
                margin-bottom: 20px;
            }
        }

        img {
            display: block !important;
            margin: 20px auto !important;
            max-width: 90% !important;
        }
    }
}
</style>
